import { ActivityStatus } from "./constants";

export function isTerminalStatus(status: ActivityStatus | undefined): boolean {
    return status === ActivityStatus.Completed || status === ActivityStatus.Failed;
}

export function isActiveStatus(status: ActivityStatus | undefined): boolean {
    return status === ActivityStatus.Running || status === ActivityStatus.Pending;
}
